import useWindowDimensions from "../../hooks/useWindowDimensions";
import GoogleMap from "../GoogleMap";
import ContactForm from "./ContactForm";
import ContactInfo from "./ContactInfo";

const Contact = () => {
  const { height } = useWindowDimensions();

  return (
    <section id="contactus" data-nav-tooltip="Contact Me" className="pp-section pp-scrollable section dark-bg" style={{ height: `${height}px` }}>
      <div className="container">
        <div className="title">
          <h3>Get in touch.</h3>
        </div>
        <div className="row">
          <div className="col-lg-5 col-xl-4 m-15px-tb">
            <ContactInfo />
          </div>
          <div className="col-lg-7 col-xl-8 m-15px-tb">
            <div className="contact-form">
              <h4>Say Something</h4>
              <ContactForm />
            </div>
          </div>
          <div className="col-12">
            <GoogleMap />
          </div>
        </div>
      </div>
    </section>
  );
};
export default Contact;
